<template>
  <div style="width: 1200px; margin: auto">
    <div class="buyid">
      <p><span>采购单号:</span>{{ code }}</p>
    </div>
    <div class="main">
      <div class="navs_top">
        <div class="left">
          <h3 class="nav_top" :title="info.title">标题： {{ info.title }}</h3>

          <div class="nav_content">
            <p>
              <span>送货地址:</span>
              {{ info.address }}
            </p>
            <p>
              <span>招标对接联系人:</span>
              {{ info.contactPerson }}
            </p>
            <p>
              <span>招标对接联系方式:</span>
              {{ info.phone }}
            </p>
          </div>
        </div>
        <div>
          <div class="endtime">
            <flipDown
              :endDate="`${new Date(info.quoteEndTime).getTime()}`"
              :timeUnit="timeUnit"
            />
          </div>
          <el-button
            v-if="info.active !== 3"
            :class="isBan ? 'startbtn startbtnBan' : 'startbtn'"
            :disabled="isBan"
            @click="handleQuotedPrice()"
            >{{
              hasQuoted == 1
                ? quoteControlNum != ""
                  ? "第" + quoteControlNum + "轮报价"
                  : "再次报价"
                : "立即报价"
            }}</el-button
          >
          <el-button
            v-if="info.active == 3"
            :class="isWinning ? 'startbtn startbtnBanB' : 'startbtn startbtnBan'"
            disabled
            >{{ isWinning ? "已中标" : "报价已结束" }}</el-button
          >
        </div>
      </div>
      <div class="nav_step">
        <el-steps :active="info.active" finish-status="success">
          <el-step
            v-for="(deliverItem, index) in deliver"
            :key="index"
            :title="deliverItem.name"
            :description="deliverItem.context"
            class="steps"
          ></el-step>
        </el-steps>
      </div>
      <div class="main_top"></div>
      <div>
        <div class="main-flag">
          <b></b>
          <span>商务要求</span>
        </div>
        <div class="flag_content">
          <p><span>补充说明：</span>{{ info.desc }}</p>
          <p class="ament">
            <span>附件：</span>
            <el-link
              v-if="info.attachment !== ''"
              :underline="false"
              type="primary"
              :href="info.attachment"
              target="_blank"
              ><i class="el-icon-download">点击下载</i></el-link
            ><span v-else>暂无附件</span>
          </p>
        </div>
      </div>

      <div class="main_content" v-if="typeshop == 1">
        <template>
          <div class="main-flag">
            <b></b>
            <span>采购商品</span>
          </div>
          <el-table
            :header-cell-style="headClass"
            :data="purchaseTableData"
            style="width: 100%"
          >
            <el-table-column type="index" label="序号"> </el-table-column>
            <el-table-column prop="productName" label="产品名称">
            </el-table-column>
            <el-table-column prop="spec" label="规格型号"> </el-table-column>
            <el-table-column prop="technicalRqmts" label="技术参数要求">
            </el-table-column>
            <el-table-column prop="unit" label="单位"> </el-table-column>

            <el-table-column prop="brand" label="品牌"> </el-table-column>
            <el-table-column prop="deliverDays" label="时效(天)">
            </el-table-column>

            <el-table-column prop="priceLimit" label="单价上限">
            </el-table-column>
            <el-table-column prop="number" label="数量"> </el-table-column>
            <el-table-column prop="remark" label="备注"> </el-table-column>
          </el-table>
        </template>
      </div>
      <div class="main_content" v-if="typeshop != 1">
        <template>
          <div class="main-flag">
            <b></b>
            <span>采购商品</span>
          </div>
          <el-table
            :header-cell-style="headClass"
            :data="purchaseTableData"
            style="width: 100%"
          >
            <el-table-column type="index" label="序号"> </el-table-column>
            <el-table-column prop="projectName" label="项目名称">
            </el-table-column>
            <el-table-column prop="workDescs" label="工作描述">
            </el-table-column>
            <el-table-column prop="calculateUnit" label="计量单位">
            </el-table-column>
            <el-table-column prop="quantities" label="工程量">
            </el-table-column>

            <el-table-column prop="brandAndModel" label="品牌-型号">
            </el-table-column>
            <!--      更改内容      -->
            <el-table-column prop="stuffPrice" label="设备材料单价">
            </el-table-column>

            <el-table-column prop="manMadePrice" label="人工单价">
            </el-table-column>
            <el-table-column prop="synthesizePrice" label="综合单价">
            </el-table-column>
            <el-table-column prop="allPrice" label="合价"> </el-table-column>
            <!--      更改内容      -->
            <el-table-column prop="remark" label="备注"> </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import countDown from "@/components/countDown"; // 倒计时
import flipDown from "vue-flip-down";
import { mapState, mapMutations } from "vuex";
import { detailsForSupplier } from "@/api/xunyou";
export default {
  data() {
    return {
      timeUnit: ["天", "时", "分", "秒"],
      id: "",
      code: "",
      type: JSON.parse(localStorage.getItem("userdata")).type, //1-供应商，3-采购商
      info: {},
      remark: "",
      area: "",
      purchaseTableData: [],
      deliver: [],
      loading: true,
      typeshop: "",
      hasQuoted: "", // 1 修改报价 2为立即报价
      quoteControlNum: "", //报价次数
      quoteId: "",
      userdata: JSON.parse(localStorage.getItem("userdata")),
      isBan: false, //报价权限/第一轮没限制，之后的需要邀请.报价时间结束时停止报价
      isWinning: false, //中标状态
    };
  },
  // 注册组件
  components: {
    countDown,
    flipDown,
  },
  created() {
    this.id = this.$route.query.id;
    this.code = this.$route.query.code;
    this.hasQuoted = this.$route.query.hasQuoted;
    // console.log(this.hasQuoted)
    this.handelData();

    console.log("00000000000000", this.userdata);
  },
  computed: {
    ...mapState(["getprovince"]),
  },
  methods: {
    //附件
    handeament() {
      console.log(this.info.attachment, "attachment");
    },
    //查询数据
    handelData() {
      this.loading = false;
      detailsForSupplier({ purchaseOrderId: this.id }).then((res) => {
        if (res.code == 0) {
          this.purchaseTableData = res.data.detailsList;
          console.log(this.purchaseTableData, "purchaseTableData");
          this.info = res.data;
          this.deliver = this.info.stepList;
          this.status = res.data.status;
          this.typeshop = res.data.type;
          this.quoteControlNum = res.data.quoteControl.num;
          this.quoteId = res.data.quoteControl.id;
          // 判断时候超时
          var endTime = Date.parse(this.info.quoteEndTime);
          var presentTime = Date.now();
          // console.log('时间戳',endTime,presentTime);
          // if(endTime < presentTime){
          //   console.log('超时');
          //   this.isBan = true
          // }
          // 判断第二轮之后的报价是否邀请
          console.log(res.data.quoteControl.num);
          if (res.data.quoteControl.num > 1 && res.data.quoteControl.ids) {
            let ids = res.data.quoteControl.ids;
            // ids = "95,94,360"
            ids = ids.split(",").map(Number);
            if (ids.indexOf(this.userdata.userId) > -1) {
              // console.log("存在");
            } else {
              // console.log("不存在");
              this.isBan = true;
            }
          }

          // 报价结束
          if (res.data.status == "5") {
            // this.info.quoteEndTime = ''
            this.isBan = true;
            // 判断中标
            if (res.data.winningUid == this.userdata.userId) {
              this.isWinning = true;
            }
          }else if(res.data.status == "4"||res.data.status == "5"||res.data.status == "6"||res.data.status == "7"){
            this.info.quoteEndTime = ''
          }

        }
      });
    },
    // 表头样式设置
    headClass() {
      return "background:#eef1f6;color:black";
    },
    //立即报价
    handleQuotedPrice() {
      if (this.type == 1) {
        if (this.type == 1) {
          this.$router.push(
            `/SupplierQuotation?id=${this.id}&code=${this.code}&status=${this.status}&hasQuoted=${this.hasQuoted}&ids=${this.quoteId}`
          );
          //供应商
        }
      }
    },
    //上传成功
    //   退款凭证上传
    handleAvatarSuccess(res, file) {
      //  this.urlImg = URL.createObjectURL(file.raw) // 用来图片预览的
      //    this.sizeForm.proof =res.url;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    //选择商品表格内编辑

    handelDownload() {
      console.log("下载合同");
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-step__head.is-process {
  color: #67c23a;
  border-color: #67c23a;
}
/deep/.el-step__title.is-process {
  font-weight: bold;
  color: #5fb878;
}
/deep/.vue-countdown-component .time-box,
/deep/.vue-countdown-component .time-box > div.back.anime,
/deep/.vue-countdown-component .time-box > div.face,
/deep/.vue-countdown-component .time-box > div.base .base-b {
  background-color: #d33a31 !important;
}
/deep/.el-step__head.is-success {
  color: #c65442;
  border-color: #c65442;
}
/deep/.el-step__title.is-success {
  color: #c65442;
}
/deep/.el-step__description.is-success {
  color: #c65442;
}
.buyid {
  display: flex;
  justify-content: space-between;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  margin-left: 30px;
  span {
    color: gray;
  }
  p:last-child {
    cursor: pointer;
    color: gray;

    i {
      margin-left: 10px;
      color: #000;
    }
  }
}

.endtime {
  color: red;
  font-weight: bold;
  margin-right: 50px;
  font-size: 16px;
  margin-top: 10px;
  display: inline-block;
}
.main {
  background-color: white;
  padding: 20px;
  .navs_top {
    display: flex;
    justify-content: space-between;
    .left {
      width: 55%;
    }
  }
  .bottom {
    margin: 30px 0;
    display: flex;
    justify-content: center;
    .nav_right {
      display: flex;
      justify-content: space-between;

      .count {
        margin-top: 10px;
        margin-right: 50px;
        font-size: 16px;
        font-weight: bold;
        span {
          color: #ff2a58;
        }
      }
    }
  }

  .nav_step {
    // width: 50%;
    color: gray;
    margin: 40px 0;
  }

  .nav_top {
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    font-weight: bold;
    width: 600px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .nav_content {
    display: flex;
    justify-content: space-between;
    p {
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      font-weight: bold;
    }
    span {
      font-weight: normal;
      color: gray;
    }
  }
}
.startbtn {
  color: white;
  width: 100px;
  height: 40px;
  line-height: 20px;
  background-color: #c65442;
  padding: 10px;
}
.startbtnBan {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}
.startbtnBanB{
  color: #5fb878;
  cursor: not-allowed;
  background-image: none;
  font-weight: bolder;
  background-color: #fff;
  border-color: #5fb878;
}

.main_top {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 40px;
  border-bottom: 2.5px dotted #e3e3e3;
}
.main_content {
  margin-top: 30px;
  padding-bottom: 50px;
  .pricebtn {
    border: 1px solid #c65442;
    color: #c65442;
  }
}
.main-flag {
  margin-bottom: 20px;

  b {
    display: inline-block;
    width: 3px;
    height: 18px;
    background: #c6523f;
    vertical-align: middle;
  }
  span {
    font-weight: bold;
    font-size: 18px;
    padding-left: 8px;
    vertical-align: middle;
  }
}
.ament {
  cursor: pointer;
}
.flag_content {
  p {
    font-size: 14px;
    height: 30px;

    span {
      color: gray !important;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/procurementTenders/procurementDetails.vue